import { PatientAction } from "src/features/patient/actions";
import { PatientState } from "src/features/patient/types";

const initialState: PatientState = {};

export function patientReducer(
	state: PatientState = initialState,
	action: PatientAction
): PatientState {
	if (action.type === "FETCH_PATIENT_START") {
		const { patientId } = action.payload;
		return {
			...state,
			[patientId]: { isLoading: true, error: null, patient: null }
		};
	}
	if (action.type === "FETCH_PATIENT_SUCCESS") {
		const { patientId, patient } = action.payload;
		return {
			...state,
			[patientId]: { ...state[patientId], isLoading: false, patient }
		};
	}
	if (action.type === "FETCH_PATIENT_FAILURE") {
		const { patientId, error } = action.payload;
		return {
			...state,
			[patientId]: { ...state[patientId], isLoading: false, error }
		};
	}
	return state;
}
